export default "__VITE_ASSET__BfOmZS$o__"